import 'css-chunksrc/client/scenes/calendar/navigation/dateTimeInput/styles.scss';export default {
  "root": "_root_1304y_1",
  "inputBox": "_inputBox_1304y_5",
  "arrow": "_arrow_1304y_14",
  "leftArrowWrapper": "_leftArrowWrapper_1304y_22",
  "rightArrowWrapper": "_rightArrowWrapper_1304y_35",
  "calendarButton": "_calendarButton_1304y_48",
  "leftArrow": "_leftArrow_1304y_22",
  "rightArrow": "_rightArrow_1304y_35",
  "title": "_title_1304y_74",
  "calendarIcon": "_calendarIcon_1304y_86",
  "dateTimeInput": "_dateTimeInput_1304y_93"
};